import LiferayService from "./liferay";

class ResetPwdService {
    static verifyEmail=(email)=> LiferayService.post("o/df-reset-pass/pwd/verify-email", { email: email })
    static validateResetToken=(payload)=> LiferayService.get(`o/df-reset-pass/pwd/validate-reset-token/${payload}`) 
    static verifyOtp=(payload)=> LiferayService.post("o/df-reset-pass/pwd/verify-otp", payload)
    static resetPassword=(payload)=> LiferayService.post("o/df-reset-pass/pwd/reset-password", payload)
}
export default ResetPwdService;

